import React, { useEffect, useState } from "react";

/**
 * BioCursor — desktop-only delicate cursor companion.
 * Renders a soft copper halo + a tiny molecule trail that follows the pointer.
 * Hidden on touch / coarse pointer devices.
 */
export const BioCursor = () => {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [trail, setTrail] = useState([]);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) {
            return undefined;
        }
        let lastTrailTime = 0;
        const onMove = (e) => {
            setPos({ x: e.clientX, y: e.clientY });
            setVisible(true);
            const now = performance.now();
            if (now - lastTrailTime > 80) {
                lastTrailTime = now;
                const id = now;
                setTrail((t) =>
                    [...t, { id, x: e.clientX, y: e.clientY }].slice(-7),
                );
                setTimeout(() => {
                    setTrail((t) => t.filter((p) => p.id !== id));
                }, 1200);
            }
        };
        const onLeave = () => setVisible(false);
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseleave", onLeave);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseleave", onLeave);
        };
    }, []);

    if (!visible) return null;

    return (
        <div
            data-testid="bio-cursor"
            aria-hidden
            className="fixed inset-0 z-[60] pointer-events-none hidden md:block"
        >
            {/* soft halo */}
            <div
                className="absolute h-12 w-12 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[hsl(var(--brand-copper))]/20 blur-2xl transition-transform duration-150"
                style={{ left: pos.x, top: pos.y }}
            />
            {/* trail dots fading out */}
            {trail.map((p, i) => (
                <div
                    key={p.id}
                    className="absolute h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[hsl(var(--brand-copper))] mix-blend-screen"
                    style={{
                        left: p.x,
                        top: p.y,
                        opacity: ((i + 1) / trail.length) * 0.45,
                        transform: `translate(-50%, -50%) scale(${
                            0.4 + (i / trail.length) * 0.8
                        })`,
                        transition: "opacity 1.1s linear, transform 1.1s linear",
                    }}
                />
            ))}
        </div>
    );
};

export default BioCursor;
